var vars = require('./core');

module.exports = vars.createClass('PolarArea', ['getSegmentsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/polar-area.js
// module id = 1139
// module chunks = 0